
import { Routes } from "@angular/router";
import {
  DatabaseMigrationsComponent,
  DatabaseUpdatesComponent,
  DemouserManagementComponent,
  EditProjectComponent,
  EditTenantComponent,
  EditUserProfileComponent,
  ManageApitokensComponent,
  ManageAuditComponent,
  ManageFilesComponent,
  ManageProjectsComponent,
  ManageTenantsComponent,
  ProjectRoleTemplatesComponent,
  SelectTenantComponent,
  SelectTenantDialogComponent,
  TenantGrouprolesComponent,
  CheckUserloginComponent,
  UserChangePasswordComponent,
  UserManagementComponent,
  UserShowProfileComponent
} from 'admin';
import { ProjectResolverService, TenantResolverService, UserResolverService, UserprofileResolverService, RoutingGuardTenant } from 'shared';
import { ProjectListComponent } from 'user';
import { AppSettingsComponent } from "./app-settings/app-settings.component";
import { SquirrelDashboardComponent } from "./squirrel-dashboard/squirrel-dashboard.component";
import { UserProfileComponent } from "./user-profile/user-profile.component";

export const SquirrelLayoutRouts: Routes = [

    { path: 'check-userlogin', component: CheckUserloginComponent },
    { path: 'select-tenant', component: SelectTenantComponent },
    { path: ':tenantId/all-projects', component: ProjectListComponent, canActivate: [RoutingGuardTenant]  },
    { path: ':tenantId/manage-apitokens', component: ManageApitokensComponent },
    { path: ':tenantId/manage-audit', component: ManageAuditComponent },
    { path: ':tenantId/manage-files', component: ManageFilesComponent },
    { path: ':tenantId/manage-projects', component: ManageProjectsComponent },
    { path: ':tenantId/project-role-templates', component: ProjectRoleTemplatesComponent },
    {
        path: ':tenantId/manage-projects/:id',
        component: EditProjectComponent,
        resolve: { resolvedData: ProjectResolverService }
    },
    { path: ':tenantId/manage-users', component: UserManagementComponent },
    {
        path: ':tenantId/manage-users/:id',
        component: EditUserProfileComponent,
        resolve: { resolvedData: UserResolverService }
    },
    { path: ':tenantId/manage-demousers', component: DemouserManagementComponent },
    { path: ':tenantId/manage-tenants', component: ManageTenantsComponent },
    {
        path: ':tenantId/manage-tenants/:id',
        component: EditTenantComponent,
        resolve: { resolvedData: TenantResolverService }
    },
    { path: ':tenantId/tenant-groups', component: TenantGrouprolesComponent },
    { path: ':tenantId/database-migrations', component: DatabaseMigrationsComponent },
    { path: ':tenantId/database-updates', component: DatabaseUpdatesComponent },
    { path: 'user-profile', component: UserProfileComponent },
    {
        path: 'user-profile/:id',
        component: UserProfileComponent, resolve: { resolvedData: UserprofileResolverService }
    },
    { path: 'user-show-profile', component: UserShowProfileComponent },
    {
        path: 'user-show-profile/:id',
        component: UserShowProfileComponent, resolve: { resolvedData: UserprofileResolverService }
    },
    { path: 'settings', component: AppSettingsComponent },
    { path: 'user-change-password', component: UserChangePasswordComponent },

];
